import * as Cell from '@/components/code-illustrations/cells';

import { RETENTION_CSV } from './data';

const [headRaw, ...bodyRaw] = RETENTION_CSV.split('\n');

const head = headRaw.split(',');
const body = bodyRaw.map(row => row.split(','));
const rows = body.slice(0, 6);

export default function Table() {
  return (
    <Cell.Table>
      <colgroup>
        <col style={{ width: 48 }} />
        {head.map((th, i) => (
          <col key={th} style={{ width: i === 0 ? '16%' : '23%' }} />
        ))}
        <col style={{ width: 'auto' }} />
      </colgroup>
      <thead>
        <tr>
          <th></th>
          {head.map(th => (
            <th key={th}>{th}</th>
          ))}
          <th></th>
        </tr>
      </thead>
      <tbody>
        {rows.slice(0, 9).map((row, i) => (
          <tr key={`row-${i}`}>
            <th>{i}</th>
            {row.map((v, j) => (
              <td key={`d-${i}-${j}`}>{v}</td>
            ))}
            <td></td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td>25 rows</td>
        </tr>
      </tfoot>
    </Cell.Table>
  );
}
